import React, {
    useContext, Fragment, useEffect, useState,
} from 'react';
import moment from 'moment';
import { createPortal } from 'react-dom';
import { navigate } from '@reach/router';
import $ from 'jquery';
import { PageContext } from '../../context/PageContext';

import HiddenForm from '../HiddenForm';
import VerifyContainer from './VerifyContainer';

import useUsers from '../../hooks/useUsers';
import { getApiGetVerificationAssigneesUrl } from '../../utilities/urlHelper';

const VerificationAssignees = ({ allowedIds, page }) => {
    const [assignees, setAssignees] = useState();
    const users = useUsers();
    const page_id = page.id;
    const url = getApiGetVerificationAssigneesUrl(page_id);

    useEffect(() => {
        $.get(url)
            .then(({ assignees }) => {
                setAssignees(users && users.filter(u => (assignees.includes(u.id))));
                if (assignees) {
                    allowedIds(assignees);
                }
            });
    }, [url, users]);

    return (
        <Fragment>
            {assignees
                ? (
                    <ul className="comma-list">
                        {(assignees.find(assignee => assignee.id == window.userId) ? <li>you</li> : '')}
                        {assignees.filter(assignee => assignee.id != window.userId).map((assignee, index) => (
                            <li
                                key={index}
                            >
                                {assignee.display_name}
                            </li>
                        ))}
                    </ul>
                )
                : (<span className="loading grey"> Loading</span>)}
        </Fragment>
    );
};

export default (props) => {
    const { page } = useContext(PageContext);
    const { verification_schedule_id, needs_verification } = page || {};
    const [assigneeIds, setAssigneeIds] = useState([]);
    const [showMessage, setShowMessage] = useState(true);
    if (!verification_schedule_id || !needs_verification) {
        return null;
    }

    const submitHandler = verificationId => {
        if (verificationId) {
            setShowMessage(false);
        } else {
            setShowMessage(true);
        }
    };

    const clickVerificationLink = (e) => {
        e.preventDefault();
        $('.view-verification').click();
    };
    return (
        <div className="info-message">
            <div className="message-text">
                {showMessage && (
                    <span>
                        {'This page is due for '}
                        <span
                            className="link cursor-pointer"
                            onClick={clickVerificationLink}
                        >
                        verification
                        </span>
                        {' by'}
                        <VerificationAssignees allowedIds={(assignees) => setAssigneeIds(assignees)} page={page} />
                    </span>
                )}
            </div>
            <VerifyContainer onSubmit={submitHandler} assignees={assigneeIds} page={page} />
            <button className="close-message" type="button">&times;</button>
        </div>
    );
};
